import { EndpointConfig } from '@services/api/declarations'

export const getClubSponsorsConfig : EndpointConfig = {
  storeKey: 'getClubSponsors',
  url: '/api/clubs/:clubHash/sponsors',
}

export const postCreateSponsorConfig : EndpointConfig = {
  storeKey: 'postCreateSponsor',
  url: '/api/clubs/:clubHash/sponsors',
}

export const patchUpdateSponsorConfig : EndpointConfig = {
  storeKey: 'patchUpdateSponsor',
  url: '/api/clubs/:clubHash/sponsors/:sponsorHash',
}

export const patchUpdateSponsorsOrderConfig : EndpointConfig = {
  storeKey: 'patchUpdateSponsorsOrder',
  url: '/api/clubs/:clubHash/sponsors',
}

export const deleteSponsorConfig : EndpointConfig = {
  storeKey: 'deleteSponsor',
  url: '/api/clubs/:clubHash/sponsors/:sponsorHash',
}
